import type { Alert } from '@prisma/client'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface OperationalAlertsState {
  open: Alert[]
}

const initialState: OperationalAlertsState = { open: [] }

const slice = createSlice({
  name: 'operationalAlerts',
  initialState,
  reducers: {
    setOpenAlerts(state, action: PayloadAction<Alert[]>) {
      state.open = action.payload
    },
    upsertAlert(state, action: PayloadAction<Alert>) {
      const idx = state.open.findIndex((a) => a.id === action.payload.id)
      if (idx >= 0) state.open[idx] = action.payload
      else state.open.unshift(action.payload)
    },
    removeAlert(state, action: PayloadAction<string>) {
      state.open = state.open.filter((a) => a.id !== action.payload)
    }
  }
})

export const { setOpenAlerts, upsertAlert, removeAlert } = slice.actions
export const operationalAlertsReducer = slice.reducer
export type { OperationalAlertsState }
